/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEyeCancel = createReactComponent("eye-cancel", "IconEyeCancel", [
  ["path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
  ["path", { d: "M17 21l4 -4", key: "svg-3" }]
]);

export { IconEyeCancel as default };
//# sourceMappingURL=IconEyeCancel.js.map
